import Banner from '@zenbusiness/zui/Banner';
import { superstyled } from '@zenbusiness/zui/styles';

export const StyledBanner = superstyled({
  tag: Banner,
  name: 'BannerSection',
  slot: 'StyledBanner',
  styles: {
    justifyItems: 'center',
    '.ZuiBanner-startIcon': { maxWidth: '100%' },
  },
});
